var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"content"},[_c('div',[_c('h1',[_vm._v(" There is no definition for the word '"+_vm._s(_vm.$route.params.term)+"' that is Stink or Pink. ")]),_c('div',[_c('SearchButton')],1)])])])}
var staticRenderFns = []

export { render, staticRenderFns }